// Author : NANDHAKUMAR
// Version :0.0.1
// MODIFIED DATE: 14/11/2025
import memberCollectionActionTypes from './member-collection.types';

/** ***************** GET SEARCH MEMBER LOAN LIST START *********************** */
export const fetchSearchMemberLoanListStart = (getData: any) => ({
	type: memberCollectionActionTypes.GET_SEARCH_MEMBER_LOAN_LIST_START,
	payload: getData,
});

export const getSearchMemberLoanListSuccess = (successData: any) => ({
	type: memberCollectionActionTypes.GET_SEARCH_MEMBER_LOAN_LIST_SUCCESS,
	payload: successData,
});

export const getSearchMemberLoanListFailure = (failureData: any) => ({
	type: memberCollectionActionTypes.GET_SEARCH_MEMBER_LOAN_LIST_FAILURE,
	payload: failureData,
});

export const fetchSearchMemberLoanListResponseResetStart = () => ({
	type: memberCollectionActionTypes.GET_SEARCH_MEMBER_LOAN_LIST_RESPONSE_RESET,
});

export const getSearchMemberLoanListResponseChanged = () => ({
	type: memberCollectionActionTypes.GET_SEARCH_MEMBER_LOAN_LIST_RESPONSE_CHANGED,
});
/** ***************** GET SEARCH MEMBER LOAN LIST END *********************** */

/** ***************** GET MEMBER LOAN INFO START *********************** */
export const fetchMemberLoanInfoStart = (getData: any) => ({
	type: memberCollectionActionTypes.GET_MEMBER_LOAN_INFO_START,
	payload: getData,
});

export const getMemberLoanInfoSuccess = (successData: any) => ({
	type: memberCollectionActionTypes.GET_MEMBER_LOAN_INFO_SUCCESS,
	payload: successData,
});

export const getMemberLoanInfoFailure = (failureData: any) => ({
	type: memberCollectionActionTypes.GET_MEMBER_LOAN_INFO_FAILURE,
	payload: failureData,
});

export const fetchMemberLoanInfoResponseResetStart = () => ({
	type: memberCollectionActionTypes.GET_MEMBER_LOAN_INFO_RESPONSE_RESET,
});

export const getMemberLoanInfoResponseChanged = () => ({
	type: memberCollectionActionTypes.GET_MEMBER_LOAN_INFO_RESPONSE_CHANGED,
});
/** ***************** GET MEMBER LOAN INFO END *********************** */

/** ***************** UPDATE MEMBER COLLECTION START *********************** */
export const updateMemberCollectionStart = (getData: any) => ({
	type: memberCollectionActionTypes.UPDATE_MEMBER_COLLECTION_START,
	payload: getData,
});

export const updateMemberCollectionSuccess = (successData: any) => ({
	type: memberCollectionActionTypes.UPDATE_MEMBER_COLLECTION_SUCCESS,
	payload: successData,
});

export const updateMemberCollectionFailure = (failureData: any) => ({
	type: memberCollectionActionTypes.UPDATE_MEMBER_COLLECTION_FAILURE,
	payload: failureData,
});

export const updateMemberCollectionResponseResetStart = () => ({
	type: memberCollectionActionTypes.UPDATE_MEMBER_COLLECTION_RESPONSE_RESET,
});

export const updateMemberCollectionResponseChanged = () => ({
	type: memberCollectionActionTypes.UPDATE_MEMBER_COLLECTION_RESPONSE_CHANGED,
});
/** ***************** UPDATE MEMBER COLLECTION END *********************** */

/** ***************** UPDATE MEMBER COLLECTION START *********************** */
export const updateMemberDeathStart = (getData: any) => ({
	type: memberCollectionActionTypes.UPDATE_MEMBER_DEATH_START,
	payload: getData,
});

export const updateMemberDeathSuccess = (successData: any) => ({
	type: memberCollectionActionTypes.UPDATE_MEMBER_DEATH_SUCCESS,
	payload: successData,
});

export const updateMemberDeathFailure = (failureData: any) => ({
	type: memberCollectionActionTypes.UPDATE_MEMBER_DEATH_FAILURE,
	payload: failureData,
});

export const updateMemberDeathResponseResetStart = () => ({
	type: memberCollectionActionTypes.UPDATE_MEMBER_DEATH_RESPONSE_RESET,
});

export const updateMemberDeathResponseChanged = () => ({
	type: memberCollectionActionTypes.UPDATE_MEMBER_DEATH_RESPONSE_CHANGED,
});
/** ***************** UPDATE MEMBER COLLECTION END *********************** */

/** ***************** UPDATE MEMBER COLLECTION START *********************** */
export const updateInterestWaiverStart = (getData: any) => ({
	type: memberCollectionActionTypes.UPDATE_INTEREST_WAIVER_START,
	payload: getData,
});

export const updateInterestWaiverSuccess = (successData: any) => ({
	type: memberCollectionActionTypes.UPDATE_INTEREST_WAIVER_SUCCESS,
	payload: successData,
});

export const updateInterestWaiverFailure = (failureData: any) => ({
	type: memberCollectionActionTypes.UPDATE_INTEREST_WAIVER_FAILURE,
	payload: failureData,
});

export const updateInterestWaiverResponseResetStart = () => ({
	type: memberCollectionActionTypes.UPDATE_INTEREST_WAIVER_RESPONSE_RESET,
});

export const updateInterestWaiverResponseChanged = () => ({
	type: memberCollectionActionTypes.UPDATE_INTEREST_WAIVER_RESPONSE_CHANGED,
});
/** ***************** UPDATE MEMBER COLLECTION END *********************** */

/** ***************** FETCH MEMBER COLLECTION START *********************** */
export const fetchMemberCollectionStart = (getData: any) => ({
	type: memberCollectionActionTypes.GET_MEMBER_COLLECTION_START,
	payload: getData,
});

export const fetchMemberCollectionSuccess = (successData: any) => ({
	type: memberCollectionActionTypes.GET_MEMBER_COLLECTION_SUCCESS,
	payload: successData,
});

export const fetchMemberCollectionFailure = (failureData: any) => ({
	type: memberCollectionActionTypes.GET_MEMBER_COLLECTION_FAILURE,
	payload: failureData,
});

export const fetchMemberCollectionResponseResetStart = () => ({
	type: memberCollectionActionTypes.GET_MEMBER_COLLECTION_RESPONSE_RESET,
});

export const fetchMemberCollectionResponseChanged = () => ({
	type: memberCollectionActionTypes.GET_MEMBER_COLLECTION_RESPONSE_CHANGED,
});
/** ***************** FETCH MEMBER COLLECTION END *********************** */

/** ***************** FETCH MEMBER WALLET START *********************** */
export const fetchMemberWalletStart = (getData: any) => ({
	type: memberCollectionActionTypes.GET_MEMBER_WALLET_START,
	payload: getData,
});

export const fetchMemberWalletSuccess = (successData: any) => ({
	type: memberCollectionActionTypes.GET_MEMBER_WALLET_SUCCESS,
	payload: successData,
});

export const fetchMemberWalletFailure = (failureData: any) => ({
	type: memberCollectionActionTypes.GET_MEMBER_WALLET_FAILURE,
	payload: failureData,
});

export const fetchMemberWalletResponseResetStart = () => ({
	type: memberCollectionActionTypes.GET_MEMBER_WALLET_RESPONSE_RESET,
});

export const fetchMemberWalletResponseChanged = () => ({
	type: memberCollectionActionTypes.GET_MEMBER_WALLET_RESPONSE_CHANGED,
});
/** ***************** FETCH MEMBER WALLET END *********************** */

/** ***************** ADD MEMBER WALLET START *********************** */
export const addMemberWalletStart = (getData: any) => ({
	type: memberCollectionActionTypes.ADD_MEMBER_WALLET_START,
	payload: getData,
});

export const addMemberWalletSuccess = (successData: any) => ({
	type: memberCollectionActionTypes.ADD_MEMBER_WALLET_SUCCESS,
	payload: successData,
});

export const addMemberWalletFailure = (failureData: any) => ({
	type: memberCollectionActionTypes.ADD_MEMBER_WALLET_FAILURE,
	payload: failureData,
});

export const addMemberWalletResponseResetStart = () => ({
	type: memberCollectionActionTypes.ADD_MEMBER_WALLET_RESPONSE_RESET,
});

export const addMemberWalletResponseChanged = () => ({
	type: memberCollectionActionTypes.ADD_MEMBER_WALLET_RESPONSE_CHANGED,
});
/** ***************** ADD MEMBER WALLET END *********************** */

/** ***************** FETCH MEMBER COLLECTION START *********************** */
export const fetchMemberQrStart = (getData: any) => ({
	type: memberCollectionActionTypes.GET_MEMBER_QR_START,
	payload: getData,
});

export const fetchMemberQrSuccess = (successData: any) => ({
	type: memberCollectionActionTypes.GET_MEMBER_QR_SUCCESS,
	payload: successData,
});

export const fetchMemberQrFailure = (failureData: any) => ({
	type: memberCollectionActionTypes.GET_MEMBER_QR_FAILURE,
	payload: failureData,
});

export const fetchMemberQrResponseResetStart = () => ({
	type: memberCollectionActionTypes.GET_MEMBER_QR_RESPONSE_RESET,
});

export const fetchMemberQrResponseChanged = () => ({
	type: memberCollectionActionTypes.GET_MEMBER_QR_RESPONSE_CHANGED,
});
/** ***************** FETCH MEMBER COLLECTION END *********************** */

/** ***************** FETCH MEMBER COLLECTION START *********************** */
export const fetchMemberRepaymentStart = (getData: any) => ({
	type: memberCollectionActionTypes.GET_MEMBER_REPAYMENT_START,
	payload: getData,
});

export const fetchMemberRepaymentSuccess = (successData: any) => ({
	type: memberCollectionActionTypes.GET_MEMBER_REPAYMENT_SUCCESS,
	payload: successData,
});

export const fetchMemberRepaymentFailure = (failureData: any) => ({
	type: memberCollectionActionTypes.GET_MEMBER_REPAYMENT_FAILURE,
	payload: failureData,
});

export const fetchMemberRepaymentResponseResetStart = () => ({
	type: memberCollectionActionTypes.GET_MEMBER_REPAYMENT_RESPONSE_RESET,
});

export const fetchMemberRepaymentResponseChanged = () => ({
	type: memberCollectionActionTypes.GET_MEMBER_REPAYMENT_RESPONSE_CHANGED,
});
/** ***************** FETCH MEMBER COLLECTION END *********************** */

/** ***************** FETCH MEMBER COLLECTION START *********************** */
export const revertMemberWalletStart = (getData: any) => ({
	type: memberCollectionActionTypes.DELETE_MEMBER_WALLET_START,
	payload: getData,
});

export const revertMemberWalletSuccess = (successData: any) => ({
	type: memberCollectionActionTypes.DELETE_MEMBER_WALLET_SUCCESS,
	payload: successData,
});

export const revertMemberWalletFailure = (failureData: any) => ({
	type: memberCollectionActionTypes.DELETE_MEMBER_WALLET_FAILURE,
	payload: failureData,
});

export const revertMemberWalletResponseResetStart = () => ({
	type: memberCollectionActionTypes.DELETE_MEMBER_WALLET_RESPONSE_RESET,
});

export const revertMemberWalletResponseChanged = () => ({
	type: memberCollectionActionTypes.DELETE_MEMBER_WALLET_RESPONSE_CHANGED,
});
/** ***************** FETCH MEMBER COLLECTION END *********************** */

/** ***************** UPDATE MEMBER COLLECTION START *********************** */
export const revertMemberCollectionStart = (getData: any) => ({
	type: memberCollectionActionTypes.REVERT_MEMBER_COLLECTION_START,
	payload: getData,
});

export const revertMemberCollectionSuccess = (successData: any) => ({
	type: memberCollectionActionTypes.REVERT_MEMBER_COLLECTION_SUCCESS,
	payload: successData,
});

export const revertMemberCollectionFailure = (failureData: any) => ({
	type: memberCollectionActionTypes.REVERT_MEMBER_COLLECTION_FAILURE,
	payload: failureData,
});

export const revertMemberCollectionResponseResetStart = () => ({
	type: memberCollectionActionTypes.REVERT_MEMBER_COLLECTION_RESPONSE_RESET,
});

export const revertMemberCollectionResponseChanged = () => ({
	type: memberCollectionActionTypes.REVERT_MEMBER_COLLECTION_RESPONSE_CHANGED,
});
/** ***************** UPDATE MEMBER COLLECTION END *********************** */

/** ***************** MEMBER LOAN CARD PDF START *********************** */
export const getMemeberLoanCardPDFStart = (getData: any) => ({
	type: memberCollectionActionTypes.MEMBER_LOAN_CARD_PDF_START,
	payload: getData,
});

export const getMemeberLoanCardPDFSuccess = (successData: any) => ({
	type: memberCollectionActionTypes.MEMBER_LOAN_CARD_PDF_SUCCESS,
	payload: successData,
});

export const getMemeberLoanCardPDFFailure = (failureData: any) => ({
	type: memberCollectionActionTypes.MEMBER_LOAN_CARD_PDF_FAILURE,
	payload: failureData,
});

export const getMemeberLoanCardPDFResponseReset = () => ({
	type: memberCollectionActionTypes.MEMBER_LOAN_CARD_PDF_RESPONSE_RESET,
});

export const getMemeberLoanCardPDFResponseChanged = () => ({
	type: memberCollectionActionTypes.MEMBER_LOAN_CARD_PDF_RESPONSE_CHANGED,
});

/** ***************** MEMBER LOAN CARD PDF END *********************** */

/** ***************** MEMBER REPAYMENT PDF START *********************** */
export const getMemeberRepaymentPDFStart = (getData: any) => ({
	type: memberCollectionActionTypes.MEMBER_REPAYMENT_PDF_START,
	payload: getData,
});

export const getMemebeRepaymentPDFSuccess = (successData: any) => ({
	type: memberCollectionActionTypes.MEMBER_REPAYMENT_PDF_SUCCESS,
	payload: successData,
});

export const getMemeberRepaymentPDFFailure = (failureData: any) => ({
	type: memberCollectionActionTypes.MEMBER_REPAYMENT_PDF_FAILURE,
	payload: failureData,
});

export const getMemeberRepaymentPDFResponseReset = () => ({
	type: memberCollectionActionTypes.MEMBER_REPAYMENT_PDF_RESPONSE_RESET,
});

export const getMemeberRepaymentPDFResponseChanged = () => ({
	type: memberCollectionActionTypes.MEMBER_REPAYMENT_PDF_RESPONSE_CHANGED,
});

/** ***************** MEMBER REPAYMENT PDF END *********************** */

/** ***************** MEMBER LOAN CARD REPORT START *********************** */
export const getMemeberLoanCardReportStart = (getData: any) => ({
	type: memberCollectionActionTypes.MEMBER_LOAN_CARD_REPORT_START,
	payload: getData,
});

export const getMemeberLoanCardReportSuccess = (successData: any) => ({
	type: memberCollectionActionTypes.MEMBER_LOAN_CARD_REPORT_SUCCESS,
	payload: successData,
});

export const getMemeberLoanCardReportFailure = (failureData: any) => ({
	type: memberCollectionActionTypes.MEMBER_LOAN_CARD_REPORT_FAILURE,
	payload: failureData,
});

export const getMemeberLoanCardReportResponseReset = () => ({
	type: memberCollectionActionTypes.MEMBER_LOAN_CARD_REPORT_RESPONSE_RESET,
});

export const getMemeberLoanCardReportResponseChanged = () => ({
	type: memberCollectionActionTypes.MEMBER_LOAN_CARD_REPORT_RESPONSE_CHANGED,
});

/** ***************** MEMBER LOAN CARD REPORT END *********************** */

/** ***************** MEMBER LOAN COLLECTION APPROVAL START *********************** */
export const memberLoanCollectionApprovalStart = (getData: any) => ({
	type: memberCollectionActionTypes.MEMBER_LOAN_COLLECTION_APPROVAL_START,
	payload: getData,
});

export const memberLoanCollectionApprovalSuccess = (successData: any) => ({
	type: memberCollectionActionTypes.MEMBER_LOAN_COLLECTION_APPROVAL_SUCCESS,
	payload: successData,
});

export const memberLoanCollectionApprovalFailure = (failureData: any) => ({
	type: memberCollectionActionTypes.MEMBER_LOAN_COLLECTION_APPROVAL_FAILURE,
	payload: failureData,
});

export const memberLoanCollectionApprovalResponseReset = () => ({
	type: memberCollectionActionTypes.MEMBER_LOAN_COLLECTION_APPROVAL_RESPONSE_RESET,
});

export const memberLoanCollectionApprovalResponseChanged = () => ({
	type: memberCollectionActionTypes.MEMBER_LOAN_COLLECTION_APPROVAL_RESPONSE_CHANGED,
});

/** ***************** MEMBER LOAN COLLECTION APPROVAL END *********************** */

/** ***************** MEMBER LOAN COLLECTION PAID START *********************** */
export const memberCollectionLoanPaidStart = (getData: any) => ({
	type: memberCollectionActionTypes.MEMBER_COLLECTION_LOAN_PAID_ENTRY_START,
	payload: getData,
});

export const memberCollectionLoanPaidSuccess = (successData: any) => ({
	type: memberCollectionActionTypes.MEMBER_COLLECTION_LOAN_PAID_ENTRY_SUCCESS,
	payload: successData,
});

export const memberCollectionLoanPaidFailure = (failureData: any) => ({
	type: memberCollectionActionTypes.MEMBER_COLLECTION_LOAN_PAID_ENTRY_FAILURE,
	payload: failureData,
});

export const memberCollectionLoanPaidReponseReset = () => ({
	type: memberCollectionActionTypes.MEMBER_COLLECTION_LOAN_PAID_ENTRY_REPONSE_RESET,
});

export const memberCollectionLoanPaidReponseChanged = () => ({
	type: memberCollectionActionTypes.MEMBER_COLLECTION_LOAN_PAID_ENTRY_RESPONSE_CHANGED,
});
/** ***************** MEMBER LOAN COLLECTION PAID END *********************** */

/** ***************** MEMBER LOAN COLLECTION ARREAR PAID START *********************** */
export const memberCollectionLoanPaidArrearStart = (getData: any) => ({
	type: memberCollectionActionTypes.MEMBER_COLLECTION_LOAN_PAID_ARREAR_ENTRY_START,
	payload: getData,
});

export const memberCollectionLoanPaidArrearSuccess = (successData: any) => ({
	type: memberCollectionActionTypes.MEMBER_COLLECTION_LOAN_PAID_ARREAR_ENTRY_SUCCESS,
	payload: successData,
});

export const memberCollectionLoanPaidArrearFailure = (failureData: any) => ({
	type: memberCollectionActionTypes.MEMBER_COLLECTION_LOAN_PAID_ARREAR_ENTRY_FAILURE,
	payload: failureData,
});

export const memberCollectionLoanPaidArrearReponseReset = () => ({
	type: memberCollectionActionTypes.MEMBER_COLLECTION_LOAN_PAID_ARREAR_ENTRY_REPONSE_RESET,
});

export const memberCollectionLoanPaidArrearReponseChanged = () => ({
	type: memberCollectionActionTypes.MEMBER_COLLECTION_LOAN_PAID_ARREAR_ENTRY_RESPONSE_CHANGED,
});
/** ***************** MEMBER LOAN COLLECTION PAID ARREAR END *********************** */

/************************ GET THRIFT COLLECTION DETAILS ACTIONS ****************** */
export const getThriftCollectionDetailsStart = (getData: any) => ({
	type: memberCollectionActionTypes.GET_THRIFT_COLLECTION_DETAILS_START,
	payload: getData,
});

export const getThriftCollectionDetailsSuccess = (successData: any) => ({
	type: memberCollectionActionTypes.GET_THRIFT_COLLECTION_DETAILS_SUCCESS,
	payload: successData,
});

export const getThriftCollectionDetailsFailure = (failureData: any) => ({
	type: memberCollectionActionTypes.GET_THRIFT_COLLECTION_DETAILS_FAILURE,
	payload: failureData,
});

export const getThriftCollectionDetailsResponseReset = () => ({
	type: memberCollectionActionTypes.GET_THRIFT_COLLECTION_DETAILS_RESPONSE_RESET,
});

export const getThriftCollectionDetailsResponseChanged = () => ({
	type: memberCollectionActionTypes.GET_THRIFT_COLLECTION_DETAILS_RESPONSE_CHANGED,
});
/************************ GET THRIFT COLLECTION DETAILS ACTIONS ****************** */

/************************ REVERT THRIFT COLLECTION ACTIONS ****************** */
export const revertThriftCollectionStart = (getData: any) => ({
	type: memberCollectionActionTypes.REVERT_THRIFT_COLLECTION_START,
	payload: getData,
});

export const revertThriftCollectionSuccess = (successData: any) => ({
	type: memberCollectionActionTypes.REVERT_THRIFT_COLLECTION_SUCCESS,
	payload: successData,
});

export const revertThriftCollectionFailure = (failureData: any) => ({
	type: memberCollectionActionTypes.REVERT_THRIFT_COLLECTION_FAILURE,
	payload: failureData,
});

export const revertThriftCollectionResponseReset = () => ({
	type: memberCollectionActionTypes.REVERT_THRIFT_COLLECTION_RESPONSE_RESET,
});

export const revertThriftCollectionResponseChanged = () => ({
	type: memberCollectionActionTypes.REVERT_THRIFT_COLLECTION_RESPONSE_CHANGED,
});
/************************ REVERT THRIFT COLLECTION ACTIONS ****************** */
